import { VideoMetadata } from "@utils/videoEditing";

export type MimeTypeInfo = { ext: string; testFile?: string };
export type FileInputDimensions = { width: number; height: number } | null;

// Media Item Types
export type MediaItemUuid = string;
export enum MediaItemFileType {
    VIDEO = "video",
    IMAGE = "image"
}

export interface MediaItemMetadata {
    frame_count: number;
    clamped_time?: number; // for video files, this is the clamped time for the current frame, for images this is 0
    segment?: number; // for video files, this is the segment for the current frame, for images this is 0
    keyframe_offset?: number; // for trimmed videos, this is the actual start time (first keyframe)
    videoMetadata?: VideoMetadata | null;
    renderedDimensions?: FileInputDimensions;
    naturalDimensions?: FileInputDimensions;
    inferredDimensions?: FileInputDimensions;
    serverMediaDimensions?: FileInputDimensions;
}

export interface MediaItemValidation {
    isValid: boolean;
    needsTrimming: boolean;
    errors: string[];
}

export enum MediaItemStatus {
    PENDING = "pending",
    UPLOADING = "uploading",
    PROCESSING = "processing",
    COMPLETED = "completed",
    ERROR = "error",
    DELETED = "deleted"
}

export enum MediaItemUploadPhase {
    UPLOADING = "uploading",
    PROCESSING = "processing",
    DOWNLOADING = "downloading"
}

export interface MediaItemUploadResult {
    downloadUrl: string;
    filename: string;
    resizeRatio?: number; // for resized images, the ratio of resized to original
}

export interface MediaItemFile extends File {
    id?: string;
    storageUploadDirOverride?: string;
    uploadResult?: MediaItemUploadResult;
    uploadResizedResult?: MediaItemUploadResult;
}

export interface MediaItem {
    id: MediaItemUuid;
    file: MediaItemFile;
    fileType: MediaItemFileType;
    status: MediaItemStatus;
    isTestFile: boolean;
    name: string;
    storageUploadDirOverride?: string;
    progress: number;
    uploadPhase?: MediaItemUploadPhase; // Current phase of upload (for videos)
    uploadPhaseText?: string; // User-friendly text for current phase
    confidenceThreshold?: number;
    isVideo: boolean;
    error?: Error;
    fileCaption?: string[];
    startTime?: number; // TODO: can this be pulled from metadata?
    uploadResult?: MediaItemUploadResult;
    uploadResizedResult?: MediaItemUploadResult; // for images, we also upload a resized version
    // video frame attrs
    frame0Id?: MediaItemUuid; // todo: remove. access from segmentToFrameMediaItemIdMap[0]
    segmentToFrameMediaItemIdMap?: Record<number, MediaItemUuid | undefined>;
    validation?: MediaItemValidation;
    metadata?: MediaItemMetadata;
}

export interface TrimTimes {
    startTime: number;
    endTime: number;
}
